import React from "react";
import { Link } from "react-router-dom";
import { IsEmpty } from "../../../util/commonFunctions";

const ConfirmAccount = props => {
  return (
    <React.Fragment>
      <div className="text-center mt50">
        {!IsEmpty(props.errorMessage) ? (
          <h3>Your account can't be confirmed</h3>
        ) : (
          <h3>Your account has been confirmed</h3>
        )}
      </div>

      <div className="text-center mar-popup-image">
        {!IsEmpty(props.errorMessage) && (
          <p className="error">{props.errorMessage}</p>
        )}
        {IsEmpty(props.errorMessage) && (
          <img src="/assets/svg/confirmSuccess.svg" alt="confirmed" />
        )}
      </div>
      <div className="text-center">
        {IsEmpty(props.errorMessage) && (
          <p className="mb20 sub opacity">
            For security purposes, you may be asked to sign in again.
          </p>
        )}
      </div>
      <div className="text-center mt75">
        <Link to="/signin" className="btn continue active">
          Continue
        </Link>
      </div>
    </React.Fragment>
  );
};

export default ConfirmAccount;
